



























import {Vue, Component, Prop, Watch} from "vue-property-decorator"
import {Random} from 'hcore/dist/random';
import $ from 'jquery';

@Component({

})
export default class Modal extends Vue {
    @Prop({type: Boolean})
    public isOpen!: boolean;

    @Prop()
    public title!: string;

    @Prop({type: String})
    public size!: string;

    private id: string = "";

    created() {
        this.id = Random.alphanumeric(10);
        this.$nextTick(() => {
            $(`#${this.id}`).on('hidden.bs.modal', (e) => {
                this.$emit('close');
            })
        })
    }

    public open() {
        // @ts-ignore
        $(`#${this.id}`).modal('show');
        this.$emit('open');
    }

    public close() {
        // @ts-ignore
        $(`#${this.id}`).modal('hide');
        this.$emit('close');
    }

    @Watch('isOpen')
    public isOpenChange() {
        if (this.isOpen) this.open();
        else this.close();
    }
}


